<template>
    <div class="scanner wrapper m-lg-3 p-lg-4 d-flex flex-column">
        <div class="event-controls flex-shrink-0 d-lg-none">
            <button v-on:click="goBack" class="btn btn-secondary">{{ $t('events.back') }}</button>
        </div>
        <qrcode-reader @decode="onDecode" :paused="paused" class="flex-grow-1 flex-shrink-1 align-items-end">
            <div v-if="successmsg" class="alert alert-success" role="alert">
                <span v-html="successmsg"></span>
                <button class="btn btn-secondary" v-on:click="onContinue">{{ $t('events.continue') }}</button>
            </div>
            <div v-if="errormsg" class="alert alert-danger" role="alert">
                <span v-html="errormsg"></span>
                <button class="btn btn-secondary" v-on:click="onContinue">{{ $t('events.continue') }}</button>
            </div>
            <div v-if="warningmsg" class="alert alert-warning" role="alert">
                <span v-html="warningmsg"></span>
                <button class="btn btn-secondary" v-on:click="onContinue">{{ $t('events.continue') }}</button>
            </div>
        </qrcode-reader>
        <div class="text-right">
            <button v-on:click="goBack" class="btn btn-link text-secondary">{{ $t('events.stopscan') }}</button>
        </div>
    </div>
</template>

<script>
    import _ from 'underscore';

    export default {
        name: 'scanner',
        data() {
            return {
                successmsg: null,
                errormsg: null,
                warningmsg: null,
                pause: false,
            };
        },
        computed: {
            attendees() {
                if (!this.event) return [];
                return this.event.attendees;
            },
            event() {
                const id = this.$route.query.id;
                const event = this.$store.state.events.list.find(ev => ev._id === id);
                if (event && !event.attendees.loaded) this.$store.dispatch('fetchAttendees', id);
                return event;
            },
            paused() {
                return !!this.successmsg || !!this.errormsg || !!this.warningmsg || this.pause;
            },
        },
        methods: {
            onContinue() {
                this.successmsg = null;
                this.errormsg = null;
                this.warningmsg = null;
                this.pause = false;
            },
            goBack() {
                // this.onContinue();
                this.pause = true;
                const id = this.$route.query.id;
                this.$router.push({ path: 'events', query: { id: id }});
            },
            onDecode(id) {
                this.pause = true;

                if (!id) return this.pause = false;
                const attendee = this.attendees.find(function (attendee) {
                    // TODO need some modification maybe
                    return attendee.identifier === id;
                });
                if (!attendee) return this.errormsg = this.$t('events.scanerror', { id: id });

                const modified = _.extend({}, attendee, { status: 'attending' });

                this.$store.dispatch('updateAttendee', modified).then((res) => {
                    let data = res.body.identifier;
                    if (res.body.data && res.body.data.length > 0) data = res.body.data.join(', ');
                    this.successmsg = this.$t('events.scansuccess', { data: data });
                }).catch((err) => {
                    if (err.status === 406) {
                        let data = attendee.identifier;
                        if (attendee.data && attendee.data.length > 0) data = attendee.data.join(', ');
                        this.warningmsg = this.$t('events.scanwarning', { data: data });
                        return;
                    }
                    this.errormsg = this.$t('internalerror');
                    console.error(err)
                });
            },
        }
    };
</script>

<style lang="scss">
    .scanner {
        .qrcode-reader {
            overflow: hidden;
        }

        .qrcode-reader__overlay > * {
            margin: 2px;
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
        }

        @media (max-width: 575px) {
            .alert button {
                margin-top: 1em;
                width: 100%;
            }
        }
    }
</style>